import React from "react";
import AboutIllustration from "../../assets/images/about-illustration.png"
import {ReactComponent as IcStars} from "../../assets/icons/ic-stars.svg"

export const About = () => {
    return (
        <div className="flex flex-col lg:flex-row justify-between items-center text-left p-4 sm:p-6 md:p-8 lg:p-10 space-y-8 lg:space-y-0 lg:space-x-8">
            <div className="w-full lg:w-1/2 order-2 lg:order-1">
                <p className="text-xs sm:text-sm text-[#548CA8]">About Agiros</p>
                <h1 className="text-xl sm:text-2xl md:text-3xl lg:text-3xl xl:text-4xl font-semibold pt-3 md:pt-4 leading-tight max-w-full lg:max-w-96">
                    Bibit Parfum Terbaik untuk Menyempurnakan Harimu
                </h1>
                <p className="text-[#404040] pt-3 md:pt-4 text-xs sm:text-sm md:text-base leading-relaxed">
                    Agiros Perfume hadir dengan berbagai pilihan bibit parfum berkualitas untuk pria dan wanita. 
                    Dengan kualitas bibit parfum yang telah teruji, produk kami siap menghadirkan keharuman yang menyegarkan 
                    hari-harimu. Kami menyediakan bibit parfum impor dalam kemasan tersegel pabrik, sehingga kamu tak perlu 
                    khawatir mengenai keaslian produk kami.
                </p>
                <div className="flex space-x-4 sm:space-x-6 pt-4 md:pt-6">
                    <div>
                        <p className="font-semibold text-xl sm:text-2xl text-[#548CA8]">2K+</p>
                        <p className="text-xs sm:text-sm text-[#404040]">Pembeli</p>
                    </div>
                    <div className="w-0.5 my-2 bg-gray-300" />
                    <div>
                        <div className="flex space-x-1 items-center">
                            <IcStars width="20px" className="sm:w-[25px]" />
                            <p className="font-semibold text-xl sm:text-2xl text-[#F89616]">5.0</p>
                        </div>
                        <p className="text-xs sm:text-sm text-[#404040]">Review</p>
                    </div>
                </div>
            </div>
            <div className="w-full lg:w-1/2 order-1 lg:order-2 flex justify-center lg:justify-end">
                <img 
                    src={AboutIllustration} 
                    alt="About Agiros Illustration" 
                    className="w-full max-w-sm sm:max-w-md md:max-w-lg lg:max-w-full h-auto object-contain"
                />
            </div>
        </div>
    )
}